<template>
    <div>
        <Icon v-if="voltage"
              icon-name="battery"
              width="24"
              height="24"
              fill="#858585"
              :title="tooltipText"
              data-toggle="tooltip"
              data-placement="top" />
    </div>
</template>

<script>

import Icon from "../../Icon";
import DeviceObject from "../../../objects/DeviceObject";
import moment from "moment-mini";
import TimeAgo from "javascript-time-ago";
import ru from 'javascript-time-ago/locale/ru.json';
import uk from 'javascript-time-ago/locale/uk.json';

export default {
    name: "DeviceCardHeaderBattery",
    components: {
        Icon
    },
    props: {
        deviceObject: {
            type: DeviceObject,
            required: true,
        },
        timeseries: {
            type: Array,
            required: false
        },
    },
    computed: {
        voltage() {
            const batVoltStat = this.timeseries.find(item => item.getSlug() === "bat_volt")?.getLatestData()?.getValue();
            return batVoltStat ? batVoltStat : null;
        },
        lastUpdate() {
            const date = this.timeseries.find(item => item.getSlug() === "bat_volt")?.getLatestData()?.getDate();

            if (moment(date).isValid()) {
                const timeAgo = new TimeAgo(this.$i18n.locale);
                return this.$t("Обновлено") + " " + timeAgo.format(new Date(date));
            }

            return "";
        },
        tooltipText() {
            return this.$t('Напряжение батареи:') + ` ${this.voltage}V ${this.lastUpdate}`;
        }
    },
    created() {
        TimeAgo.addLocale(ru);
        TimeAgo.addLocale(uk);
    },
}
</script>

<style scoped>

</style>
